const context = {
    AddressEntered: 'Address You Entered',
    AddressValidation: 'Address Validation',
    Cancel: 'Cancel',
    Close: 'Close',
    ConfirmAddress: 'The address I entered is correct. Incorrect information may result in delay or cancellation of my order.',
    LoadingSrText: 'Loading...',
    SaveAddress: 'Save Address',
    SelectSuggestedAddress: 'Please select one of the suggested options',
    SelectSuggestedFieldError: 'Please select one of the suggested options',
    UnknownAddress: 'The address entered does not validate against any known address. Please cancel and edit the address, or confirm the address you entered is correct.',
    UnknownAddressFieldError: 'Please cancel and edit the address, or confirm the address you entered is correct.',
    UpsCopyright: 'UPS, the UPS brand mark, and the Color Brown are trademarks of United Parcel Service of America, Inc. All Rights Reserved',
    UpsLogo: {
        Alt: 'UPS',
        Url: '/images-2/ups-logo.svg'
    },
    UseSuggestedAddress: 'Use Suggested Address'
};

export {
    context
};
